///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Routes } from '@angular/router';

import { passwordResetInitRoute } from './password-reset/init/password-reset-init.route';
import { passwordResetFinishRoute } from './password-reset/finish/password-reset-finish.route';
import { passwordRoute } from './password/password.route';
import { settingsRoute } from './settings/settings.route';

const ACCOUNT_ROUTES = [passwordRoute, passwordResetInitRoute, passwordResetFinishRoute, settingsRoute];

export const accountState: Routes = [
    {
        path: '',
        children: ACCOUNT_ROUTES,
        title: 'Account'
    }
];
